export default "__VITE_ASSET__BFxhVnfF__"